import { Component, OnInit } from '@angular/core';
import { LicenseState, CurrentLicense, License } from '@/core/services/utils/license-state';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@/core/services/open-api/user.service';
import { StateOption } from './state-options.interface';
@Component({
    selector: 'app-store',
    templateUrl: './store.component.html',
    // styleUrls: ['./store.component.scss'],
    standalone: false,
})
export class StoreComponent implements OnInit {
    public savings: number = 0;
    public licenses = 1;
    public activeUsers = 1;
    public currentLicense?: CurrentLicense;
    public licenseStatusText = 'Free';
    public addLicencesQuantity = 1;
    public minLicenseQuantity = 0;
    public minLicenseMessage = false;
    public yearly = true;
    stateOptions: StateOption[] = [];

    constructor(
        public readonly licenseState: LicenseState,
        private router: Router,
        private readonly translate: TranslateService,
        public userService: UserService,
    ) {}

    ngOnInit(): void {
        this.translate
            .get([
                'licenseName_free',
                'licenseName_trial',
                'licenseName_pro',
                'standard_yearly',
                'standard_monthly',
                '',
            ])
            .subscribe((translations) => {
                this.licenseState.getLicense().subscribe((license: License) => {
                    this.activeUsers = license.activeUsers;
                    this.currentLicense = license.feature.currentLicense;
                    this.licenses = license.licenses;
                    this.minLicenseQuantity = this.activeUsers - this.licenses;

                    if (this.activeUsers > this.licenses) {
                        this.addLicencesQuantity = this.activeUsers - this.licenses;
                    }
                    // initial savings
                    if (this.isYearly()) {
                        this.savings = this.addLicencesQuantity * 24;
                    }
                    if (this.currentLicense === CurrentLicense.TRIAL) {
                        this.licenseStatusText = translations.licenseName_trial;
                    } else if (this.currentLicense === CurrentLicense.PRO) {
                        this.licenseStatusText = translations.licenseName_pro;
                    } else if (this.currentLicense === CurrentLicense.FREE) {
                        this.licenseStatusText = translations.licenseName_free;
                    } else {
                        this.licenseStatusText = 'Error';
                    }
                });

                this.stateOptions = [
                    { label: translations.standard_monthly, value: false },
                    { label: translations.standard_yearly, value: true },
                ];
            });
    }

    checkMinLicences(): void {
        if (this.minLicenseQuantity > this.addLicencesQuantity) {
            this.minLicenseMessage = true;
        } else {
            this.minLicenseMessage = false;
        }

        if (this.isYearly()) {
            this.savings = this.addLicencesQuantity * 24;
        }
    }

    linkToUsers(): void {
        void this.router.navigateByUrl('/team');
    }

    public isYearly(): boolean {
        return this.yearly;
    }

    linkToBilling(): void {
        this.translate.get(['language_parameter_store_link']).subscribe((translations) => {
            this.userService.getLicensesURL().subscribe((data) => {
                const domain = data.split('?');
                const newUrl =
                    domain[0] + translations.language_parameter_store_link + '/my-account/orders' + '?' + domain[1];
                // console.debug("newUrl: " + newUrl)
                window.open(newUrl, '_self');
            });
        });
    }

    linkToAddons(): void {
        void this.router.navigateByUrl('/settings/addons');
    }

    public goToBuyLicence(addLicencesQuantity: number): void {
        this.translate
            .get([
                'language_parameter_store_link',
                'subscription_pro_plan_woocommerce_product_id',
                'subscription_pro_plan_monthly_woocommerce_product_id',
            ])
            .subscribe((translations) => {
                this.userService.getLicensesURL().subscribe((data) => {
                    // console.debug("data: " + data)
                    const domain = data.split('?');
                    const newUrl =
                        domain[0] +
                        translations.language_parameter_store_link +
                        '/cart' +
                        '?' +
                        'add-to-cart=' +
                        (this.isYearly()
                            ? translations.subscription_pro_plan_woocommerce_product_id
                            : translations.subscription_pro_plan_monthly_woocommerce_product_id) +
                        '&quantity=' +
                        addLicencesQuantity +
                        '&' +
                        domain[1]; // "&quantity=" + quantity + "&" + domain[1]
                    // console.debug("newUrl: " + newUrl)
                    window.open(newUrl, '_self'); //  _self  _blank
                });
            });
    }

    public togglePricing(event: boolean): void {
        this.yearly = event;
        if (this.isYearly()) {
            this.savings = this.addLicencesQuantity * 24;
        }
    }
}
